export default __webpack_public_path__ + "static/niseko-japan-289638557717f40f678193b2e13936f8.jpg";